import hutrit_next_hero_icon from '../images/hutrit_next_hero_icon.svg'
import { LIST_OF_GOOGLE_TAG_MANAGER_IDS } from '../../../../../utils/constants'
import { Link } from 'react-router-dom'

const Hero = () => {
  return (
    <div>
      <section
        id="landing-start-section"
        className="d-flex flex-column d-lg-none justify-content-center align-items-center px-3 lumpy-background"
        style={{
          paddingTop: '100px',
        }}
      >
        <span
          className="text-on-bg-primary bolder inline-text text-center"
          style={{
            fontSize: '32px',
            fontWeight: '1000',
          }}
        >
          HUTRIT NEXT: TU <br /> PRIMER GRAN PASO <br /> PROFESIONAL (Y NO{' '}
          <br /> ESTARÁS SOLO)
        </span>
        <img src={hutrit_next_hero_icon} width={200} />

        <div
          className="text-on-bg-secondary inline-text text-center"
          style={{
            fontSize: '14px',
          }}
        >
          BUSCA, FILTRA Y SELECCIONA TALENTO <br /> TECH Y MARKETING SIN QUE
          MUEVAS UN DEDO
        </div>
        <Link
          id={LIST_OF_GOOGLE_TAG_MANAGER_IDS.button_hero_desktop}
          className="buttonSelectLanding text-decoration-none text-on-bg-primary border border-on-bg-primary mt-3 mt-lg-0"
          to="https://hutrit.com/tm-link/IzY4MC1S/es"
        >
          Más información
        </Link>
      </section>
      <section
        id="landing-start-section"
        className="d-lg-flex d-none justify-content-center align-items-center px-5 lumpy-background"
        style={{
          height: '100vh',
        }}
      >
        <div>
          <span className="text-on-bg-primary bolder hero-card-title inline-text">
            HUTRIT NEXT: TU <br /> PRIMER GRAN PASO <br /> PROFESIONAL (Y NO{' '}
            <br /> ESTARÁS SOLO)
          </span>
          <br />
          <div className="d-flex align-items-start justify-content-start mt-5 gap-3">
            <Link
              id={LIST_OF_GOOGLE_TAG_MANAGER_IDS.button_hero_desktop}
              className="buttonSelectLanding text-decoration-none text-on-bg-primary border border-on-bg-primary"
              to="https://hutrit.com/tm-link/IzY4MC1S/es"
            >
              Más información
            </Link>
          </div>
        </div>
        <img
          src={hutrit_next_hero_icon}
          width={544}
          style={{
            marginLeft: '25px',
          }}
        />
      </section>
    </div>
  )
}

export default Hero
